import React, { Component } from 'react';
// import ReactTable from "react-table"
import $, { data } from 'jquery';
import { ToastContainer, toast } from "react-toastify";
//  import { DialogComponent } from '@syncfusion/ej2-react-popups';
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import cssu
import { tokenVerification } from './Utils';

class ServiceLineAdmin extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteAdminApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        this.state = {
            language: null,
            savingData: false,
            // data: [
            //     {
            //         id: '',
            //         answer: '',
            //         originalQuestionId: '',
            //         // categoryTags: '',
            //         autoTranslate: '',
            //         alias: '',
            //     }
            // ],
            data : [],
            pageNum: null,
            faqid: '',
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            paginationValue: 10,
            dummyUUID: "00000000-0000-0000-0000-000000000000",
            searchTerm: "",
            isLoading: true,
            noMatchingData: false
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    notifyFailToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addRow = (data) => {
        var addController = this;
        addController.state.paginationValue = addController.state.paginationValue + 5;
        if (addController.state.pageNum != 0) {
            addController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            answer: '',
            autoTranslate: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }
    notifyResponse(response) {
        toast.dismiss();
        toast(<b><img src="/my-jeeva/assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    addAdminApi = (props, e) => {

        if (this.state.savingData) {
            return;
        }
        this.setState({ savingData: true });
        var thisController = this;
        var targetId = thisController.props.location.state.serviceLineId;
        var adminName = document.getElementById("adminName" + props.id).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + props.id).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + props.id).innerText.trim();
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
        );
        // new RegExp(/^(?=.*\d).+$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.setState({ savingData: false });
            thisController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(adminName)) {
            thisController.setState({ savingData: false });
            thisController.notifyImproperName();
        } else if (!pattern.test(adminEmailId)) {
            thisController.setState({ savingData: false });
            thisController.notifyImproperEmailId();
        } else if (!contactNumberPattern.test(adminContactNumber)) {
            thisController.setState({ savingData: false });
            thisController.notifyImproperContactNumber();
        } else if (targetId == "") {
            thisController.setState({ savingData: false });
            // thisController.notifyFailToLoad();
        }
        else {

            $.ajax({
                url: "/my-jeeva-api/provider-admin",

                method: 'POST',
                data: {
                    healthSystemId: thisController.props.location.state.healthSystemId,
                    hospitalId: thisController.props.location.state.hospitalId,
                    role: "SERVICELINE_ADMIN",
                    userEmailId: document.getElementById("adminEmailId" + props.id).innerText.trim(),
                    userName: document.getElementById("adminName" + props.id).innerText.trim(),
                    userPhoneNumber: document.getElementById("adminContactNumber" + props.id).innerText.trim(),
                    serviceLineId: targetId,
                },
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.notifyAdd();
                        thisController.state.disabled = false;
                        thisController.fetchServiceLineAdminApi();
                    } else {
                        // thisController.notifyFailToLoad();
                        thisController.state.disabled = false;
                    }
                    thisController.setState({ savingData: false });
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }

    }

    notifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Service Line Admin detail has been added successfully</b>, {
            position: "top-center",

        });

    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no service line admin present. </p>
        </div>
    );

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }
    notifyFailedToAdd(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(props.id);
    }
    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    updateApi(props, e) {
        var adminName = document.getElementById("adminName" + props.id).innerText.trim();
        var adminContactNumber = document.getElementById("adminContactNumber" + props.id).innerText.trim();
        var adminEmailId = document.getElementById("adminEmailId" + props.id).innerText.trim();
        var thisController = this
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        var contactNumberPattern = new RegExp(/^(?=.*\d)[\d()+ -]{6,17}|\(\d{3}\)\s\d{3}-\d{4}$/
        );
        // new RegExp(/^(?=.*\d).+$/);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
        if (adminName == "" || adminContactNumber == "" || adminEmailId == "") {
            thisController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(adminName)) {
            thisController.notifyImproperName();
        } else if (!pattern.test(adminEmailId)) {
            thisController.notifyImproperEmailId();
        } else if (!contactNumberPattern.test(adminContactNumber)) {
            thisController.notifyImproperContactNumber();
        } else {
            var saveData = {
                id: props.id,
                serviceLineId: thisController.props.location.state.serviceLineId,
                healthSystemId: this.state.dummyUUID,
                hospitalId: this.state.dummyUUID,
                procedureId: this.state.dummyUUID,
                userRole: "SERVICELINE_ADMIN",
                userEmailId: document.getElementById("adminEmailId" + props.id).innerText.trim(),
                userName: document.getElementById("adminName" + props.id).innerText.trim(),
                userPhoneNumber: document.getElementById("adminContactNumber" + props.id).innerText.trim()
            }

            $.ajax({
                url: "/my-jeeva-api/provider",

                method: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyUpdated();
                        thisController.state.disabled = false;
                        thisController.fetchServiceLineAdminApi();
                    } else {

                        // thisController.notifyFailToLoad();
                        thisController.state.disabled = false;


                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }
    }

    notifyUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Service Line Admin details has been updated successfully</b>, {
            position: "top-center",

        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateCells(answer) {
        if ((answer == "")) {
            this.notifyMsgFieldEmpty();
            return false;
        }
        else {
            return true;
        }

    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    deleteAdminApi = (props) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (props.id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(props.id, 1);
        } else {
            var deleteData = {
                id: props.id,
                emailId: props.userEmailId,
                userRole: 'SERVICELINE_ADMIN',
                healthSystemId: deleteApiViewController.props.location.state.healthSystemId,
                hospitalId: deleteApiViewController.props.location.state.hospitalId,
                serviceLineId: deleteApiViewController.props.location.state.serviceLineId,
            }
            $.ajax({
                url: "/my-jeeva-api/delete-user",

                method: 'POST',
                data: JSON.stringify(deleteData),
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(props.id, 1);
                        deleteConstructorVariables.notifyMsgDeleteSuccess();
                        deleteConstructorVariables.fetchServiceLineAdminApi();

                    } else {
                        if (res.result != "") {
                            deleteConstructorVariables.notifyFailToDelete(res.result);
                        }
                        else {
                            // deleteConstructorVariables.notifyFailToLoad();
                        }
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            });
        }
    }
    notifyImproperEmailId() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid email ID</b>, {
            position: "top-center"
        });

    }
    notifyImproperContactNumber() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid contact number</b>, {
            position: "top-center"
        });
    }
    notifyMsgDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Service Line Admin detail has been deleted successfully</b>, {
            position: "top-center"
        });
    }

    notifyFailToDelete(response) {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    refreshData = (id) => {
        this.setState({
            editedId: id,
            disabled: false,
            isLoading: true,
            noMatchingData: false,
            data: [],
            searchTerm: ""
        });
        this.fetchServiceLineAdminApi();
    };

    fetchServiceLineAdminApi = () => {
        var thisController = this;
        var serviceLineId = thisController.props.location.state.serviceLineId;
        // if (serviceLineId == "") {
        //     serviceLineId = thisController.state.dummyUUID;
        // }
        $.ajax({
            url: "/my-jeeva-api/provider",
            method: 'GET',
            data: {
                serviceLineId: serviceLineId,
                role: "SERVICELINE_ADMIN",
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    thisController.setState({
                        data: res.result,
                        isLoading: false,
                        noMatchingData: false,
                        disabled: false
                    })
                }
                else {
                    thisController.state.noMatchingData = false;
                    thisController.state.isLoading = false;
                    thisController.setState(thisController.state);
                    // thisController.notifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    goBackFromSubTab = () => {
        var pageNum = this.props.location.state.pageNum;
        this.props.history.push({
            pathname: "/projectmgmt/service-line",
            state: {
                goBackToFaq: true,
                pageNum: pageNum,
                healthSystemId: this.props.location.state.healthSystemId,
                hospitalId: this.props.location.state.hospitalId
            }
        });
    }

    componentDidMount() {

        setTimeout(() => {
            this.fetchServiceLineAdminApi();
        }, 300);


    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    openDeletePopUp = (props) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.userName} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteAdminApi(props)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        const a = rowA[field] ? rowA[field].toLowerCase() : '';
        const b = rowB[field] ? rowB[field].toLowerCase() : '';

        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        var serviceLineId = thisController.props.location.state.serviceLineId;
        if (serviceLineId == "") {
            serviceLineId = thisController.state.dummyUUID;
        }
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/search-providers-data",
            method: "GET",
            data: {
                searchTerm: thisController.state.searchTerm,
                serviceLineId: serviceLineId,
                role: "SERVICELINE_ADMIN",
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.setState(thisController.state);
                        thisController.state.data = res.result;
                        thisController.state.noMatchingData = false;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });

    };

    clearSearchData = () => {
        var thisController = this;
        thisController.setState({ searchTerm: "" }, () => {
            thisController.fetchServiceLineAdminApi();
        });
    }

    render() {
        const { data } = this.state
        const columns = [

            {
                name: <b>Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userName'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', display: `flex`, alignItems: `center`, background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px', lineHeight: "3rem" }}
                        id={"adminName" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.userName}

                    </div>)
            },
            {
                name: <b>Email ID</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userEmailId'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', display: `flex`, alignItems: `center`, background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px', lineHeight: "3rem" }}
                        id={"adminEmailId" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.userEmailId}

                    </div>)
            },
            {
                name: <b>Contact Number</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('userPhoneNumber'),
                selector: (props) => (
                    <div name="message" className="textarea"
                        type="text"
                        style={{ height: '5vh', display: `flex`, alignItems: `center`, background: 'white', resize: 'none', borderBottom: 'none', border: (props.id == this.state.editedId || props.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.id == this.state.editedId || props.id == "") ? '2px' : 'none', paddingLeft: '2px', lineHeight: "3rem" }}
                        id={"adminContactNumber" + props.id}

                        rows="1"
                        contentEditable={!((props.id == "") ? false :
                            props.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.userPhoneNumber}

                    </div>)
            },

            {
                name: <b>Actions</b>,
                width: 100,
                // sortable: false,
                selector: (props) => (
                    <div id="action">

                        <button
                            //className="btn2 table-action-button "
                            style={{
                                backgroundColor: "#ffffff", border: "none"
                            }}>
                            <img className="img-responsive"
                                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                // title={(props.id == "") ||
                                //     (this.state.data[props.id].id == this.state.editedId) ? 'Save' : 'Edit'}

                                src={(props.id == "") ?
                                    this.saveImageSrc : ((props.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ?
                                        this.addAdminApi(props, e) :
                                        (props.id == this.state.editedId) ?
                                            this.updateApi(props, e) :
                                            this.makeCelleditable(props, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} title="Delete">
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.id) === '' ?
                                    this.fetchServiceLineAdminApi() :
                                    this.openDeletePopUp(props)}
                            // this.setState({
                            //     hideDeletePopup: true, deletePropIndex: props.id,
                            //     propsId: props
                            // })}
                            />
                        </button>

                    </div>
                ),

            },

        ]
        return (
            <div style={{ background: "#F9F9FB" }} id='serviceLineAdminTab'>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />

                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }}  >
                                <img src="assets/images/arrow.svg"
                                    style={{ paddingRight: "30%", cursor: 'pointer' }}
                                    onClick={this.goBackFromSubTab}
                                />
                            </div>
                            <div style={{ marginLeft: "-27vw" }}>
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '20px' }}>
                                    Service Line Admin</h6>
                                {/* <h6 className="taglineTxt" style={{ textAlign: 'center' }}>FAQ Answers</h6> */}
                            </div>
                            <div style={{ marginLeft: "50vw", marginTop: "1vh" }}>
                            <input
                                    type="text"
                                    style={{
                                        width: "10vw",
                                        border: "1px solid #777676",
                                        borderRadius: "3px",
                                        padding: "10px",
                                        height: "0.6vw",
                                        paddingRight: "2rem",
                                    }}
                                    value={this.state.searchTerm}
                                    onChange={this.handleSearch}
                                    placeholder="Search ..."
                                />
                                {this.state.searchTerm && (
                                    <span
                                        onClick={() => this.clearSearchData()}
                                        style={{
                                            // position: "absolute",
                                            right: "8px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#777676",
                                            fontSize: "1.2rem",
                                            fontWeight: "bold",
                                            lineHeight: 1,
                                            userSelect: "none",
                                            marginLeft: "-1vw"
                                        }}
                                    >
                                        ×
                                    </span>
                                )}
                            </div>
                            {/* Add button */}
                            <div style={{ marginLeft: "3vw" }}>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData}
                                    title="Refresh"
                                    className="btn action-button">
                                    {/* style={{ width: '45px',margin: '5px' }}>Refresh */}
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* left Menu start here*/}
                    {/* Content Header (Page header) */}
                    {/* /.content-header */}
                    {/* Custom Tabs */}
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    {!this.state.noMatchingData &&
                                        <div className="card">
                                            {this.state.isLoading && (
                                                <div style={{ padding: '20px', textAlign: 'center' }}>
                                                    <p>Loading ...</p>
                                                </div>
                                            )}
                                            {!this.state.isLoading && this.state.data.length === 0 && (
                                                <div style={{ padding: '20px', textAlign: 'center' }}>
                                                    <p>There are no service line admin present.</p>
                                                </div>
                                            )}
                                            {(!this.state.isLoading && this.state.data.length > 0) && (
                                                <DataTable
                                                    data={data}
                                                    pagination={this.state.paginationValue}
                                                    columns={columns}
                                                    // defaultPageSize={10}
                                                    // pageSizeOptions={[5, 10, 15]}
                                                    onPageChange={this.onPageChange}
                                                    page={this.state.pageNum}
                                                    noDataComponent={<this.CustomNoDataComponent />}
                                                />)}
                                        </div>
                                    }
                                    <ToastContainer className="Toast-at-center" />
                                    </div>
                            </div>
                            <div className='card'>
                                {this.state.noMatchingData &&
                                    <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                                        <p>No matching options found ...</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default ServiceLineAdmin;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ServiceLineAdmin.js